import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { CustomChartReport } from 'src/app/interfaces/custom-chart-report/custom-chart-report.interface';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { AuditFilterModel } from 'src/app/models/audit/audit-filter.model';
import { TransactionsByCompanyService } from 'src/app/services/audit/transactions-by-company.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { CompanyService } from 'src/app/services/management/company.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CustomValidators } from 'src/app/validators/custom-validators';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss'],
  standalone: false
})
export class TransactionsComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('filtersContainer') filtersContainer!: ElementRef;

  byCompany: boolean = true;
  changeFilters: boolean = false;
  customChartReport: CustomChartReport;
  dataReport: CustomTableReport;
  filtersHeight: number = 0;
  filterObserver?: ResizeObserver;
  formTransactions: FormGroup = new FormGroup({});
  listCompany: any[] = [];
  nameWindow: string = 'Transacciones';
  projectName = ProjectName.projectName;

  constructor(private companyService: CompanyService,
    private dateConverterService: DateConverterService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private transactionsByCompanyService: TransactionsByCompanyService) {
    const url = this.router.url as string
    this.byCompany = url.includes("by-company");
  }

  ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.validateForm();
    if (this.byCompany) this.getCompanies();
  }

  ngAfterViewInit() {
    this.filterObserver = new ResizeObserver(() => {
      this.filtersHeight = this.filtersContainer?.nativeElement?.offsetHeight + 70 || 0;
    });
    this.filterObserver.observe(this.filtersContainer.nativeElement);
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    this.filterObserver?.disconnect();
  }

  changeCompany(companyId: number | null) {
    if (companyId === 0 || companyId === null) {
      this.formTransactions.controls["companyId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeFilter() {
    this.changeFilters = false;
  }

  async clear() {
    this.changeFilter();
    this.validateForm();
  }

  async exportExcel() {
    if (this.changeFilters) {
      const modelRentalReportFilter = this.formTransactions.value as AuditFilterModel;
      if (this.byCompany) {
        const dateInitial = this.formTransactions.get("dateInitial")?.value;
        const initialDate = `${dateInitial.getFullYear()}-${(dateInitial.getMonth() + 1).toString().padStart(2, '0')}`;
        const period = initialDate.slice(5);
        const year = initialDate.slice(0, -3);
        const dateFinal = this.formTransactions.get("dateFinal")?.value;
        const finalDate = `${dateFinal.getFullYear()}-${(dateFinal.getMonth() + 1).toString().padStart(2, '0')}`;
        const periodFinal = finalDate.slice(5);
        const yearFinal = finalDate.slice(0, -3);

        if (finalDate < initialDate) {
          this.toastHandlerService.showToast('warning', 'La fecha final no puede ser menor a la fecha inicial.');
          return;
        }

        modelRentalReportFilter.period = Number(period);
        modelRentalReportFilter.year = Number(year);
        modelRentalReportFilter.finalPeriod = Number(periodFinal);
        modelRentalReportFilter.finalYear = Number(yearFinal);

        try {
          const response = await firstValueFrom(this.transactionsByCompanyService.exportTransactionsByCompany(modelRentalReportFilter));
          const blob = response;
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'Transacciones por Compañia.xlsx';
          a.click();
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error('Error al exportar el informe.', error);
        }
      } else {
        try {
          const response = await firstValueFrom(this.transactionsByCompanyService.exportTransactionsByUserAutheticated(modelRentalReportFilter));
          const blob = response;
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'Transacciones.xlsx';
          a.click();
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error('Error al exportar el informe.', error);
        }
      }
    } else {
      this.toastHandlerService.showToast('info', 'No se encontraron datos para exportar.');
    }
  }

  async getCompanies() {
    try {
      this.listCompany = await firstValueFrom(this.companyService.getAllCompaniesForSelectAsync());
    } catch (error) {
      console.error('Error al buscar las compañías:', error);
    }
  }

  async send() {
    if (this.formTransactions.valid) {
      const modelRentalReportFilter = this.formTransactions.value as AuditFilterModel;
      if (this.byCompany) {
        //obtengo de Período y año inicial
        const dateInitial = this.formTransactions.get("dateInitial")?.value;
        const initialDate = `${dateInitial.getFullYear()}-${(dateInitial.getMonth() + 1).toString().padStart(2, '0')}`;
        const period = initialDate.slice(5);
        const year = initialDate.slice(0, -3);
        const dateFinal = this.formTransactions.get("dateFinal")?.value;
        const finalDate = `${dateFinal.getFullYear()}-${(dateFinal.getMonth() + 1).toString().padStart(2, '0')}`;
        const periodFinal = finalDate.slice(5);
        const yearFinal = finalDate.slice(0, -3);

        if (finalDate < initialDate) {
          this.toastHandlerService.showToast('warning', 'La fecha final no puede ser menor a la fecha inicial.');
          return;
        }

        modelRentalReportFilter.period = Number(period);
        modelRentalReportFilter.year = Number(year);
        modelRentalReportFilter.finalPeriod = Number(periodFinal);
        modelRentalReportFilter.finalYear = Number(yearFinal);

        try {
          this.dataReport = await firstValueFrom(this.transactionsByCompanyService.getTransactionsByCompany(modelRentalReportFilter));
          if (this.dataReport.data && this.dataReport.data.length != 0 && this.dataReport.data.length != null) {
            this.changeFilters = true;
          } else {
            this.changeFilters = false;
            this.toastHandlerService.showToast('info', 'No se encontraron datos.');
          }
        } catch (error) {
          console.error("Error al consultar el informe:", error);
        }
      } else {
        try {
          this.dataReport = await firstValueFrom(this.transactionsByCompanyService.getTransactionsByUserAutheticated(modelRentalReportFilter));
          if (this.dataReport.data && this.dataReport.data.length != 0 && this.dataReport.data.length != null) {
            this.changeFilters = true;
            //Capturo los datos para la grafica
            const result: any = [];
            this.dataReport.data.forEach(row => {
              result.push(
                {
                  name: row.transaction,
                  value: row.quantity
                }
              );
            });
            this.customChartReport = {
              result: result,
              legendTitle: '',
              showXAxisLabel: true,
              xAxisLabel: this.dataReport.data[0].name,
              showYAxisLabel: true,
              yAxisLabel: '',
            };
          } else {
            this.changeFilters = false;
            this.toastHandlerService.showToast('info', 'No se encontraron datos.');
          }
        } catch (error) {
          console.error("Error al consultar el informe:", error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      dateInitial: {
        required: 'El campo Fecha Ini. es obligatorio.'
      },
      dateFinal: {
        required: 'El campo Fecha Fin. es obligatorio.'
      },
      companyId: {
        notNumber: 'Debe seleccionar una compañía válida.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formTransactions.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm() {
    const currentDate = new Date();
    const formattedDate = moment(currentDate).startOf('month').toDate();
    this.formTransactions = this.formBuilder.group({
      dateInitial: [this.byCompany ? formattedDate : this.dateConverterService.convertDatePreserveDay(currentDate), [Validators.required]],
      dateFinal: [this.byCompany ? formattedDate : this.dateConverterService.convertDatePreserveDay(currentDate), [Validators.required]],
      companyId: [0, [CustomValidators.numberOnlyValidator()]]
    });
  }

}
